export const TAG = 'UpdateVersionMessage';
